export const iconsList = [
  "42-group.svg",
  "500px.svg",
  "accessible-icon.svg",
  "accusoft.svg",
  "adn.svg",
  "adversal.svg",
  "affiliatetheme.svg",
  "airbnb.svg",
  "algolia.svg",
  "alipay.svg",
  "amazon-pay.svg",
  "amazon.svg",
  "amilia.svg",
  "android.svg",
  "angellist.svg",
  "angrycreative.svg",
  "angular.svg",
  "app-store-ios.svg",
  "app-store.svg",
  "apper.svg",
  "apple-pay.svg",
  "apple.svg",
  "artstation.svg",
  "asymmetrik.svg",
  "atlassian.svg",
  "audible.svg",
  "autoprefixer.svg",
  "avianex.svg",
  "aviato.svg",
  "aws.svg",
  "bandcamp.svg",
  "battle-net.svg",
  "behance.svg",
  "bilibili.svg",
  "bimobject.svg",
  "bitbucket.svg",
  "bitcoin.svg",
  "bity.svg",
  "black-tie.svg",
  "blackberry.svg",
  "blogger-b.svg",
  "blogger.svg",
  "bluetooth-b.svg",
  "bluetooth.svg",
  "bootstrap.svg",
  "bots.svg",
  "btc.svg",
  "buffer.svg",
  "buromobelexperte.svg",
  "buy-n-large.svg",
  "buysellads.svg",
  "canadian-maple-leaf.svg",
  "cc-amazon-pay.svg",
  "cc-amex.svg",
  "cc-apple-pay.svg",
  "cc-diners-club.svg",
  "cc-discover.svg",
  "cc-jcb.svg",
  "cc-mastercard.svg",
  "cc-paypal.svg",
  "cc-stripe.svg",
  "cc-visa.svg",
  "centercode.svg",
  "centos.svg",
  "chrome.svg",
  "chromecast.svg",
  "cloudflare.svg",
  "cloudscale.svg",
  "cloudsmith.svg",
  "cloudversify.svg",
  "cmplid.svg",
  "codepen.svg",
  "codiepie.svg",
  "confluence.svg",
  "connectdevelop.svg",
  "contao.svg",
  "cotton-bureau.svg",
  "cpanel.svg",
  "creative-commons-by.svg",
  "creative-commons-nc-eu.svg",
  "creative-commons-nc-jp.svg",
  "creative-commons-nc.svg",
  "creative-commons-nd.svg",
  "creative-commons-pd-alt.svg",
  "creative-commons-pd.svg",
  "creative-commons-remix.svg",
  "creative-commons-sa.svg",
  "creative-commons-sampling-plus.svg",
  "creative-commons-sampling.svg",
  "creative-commons-share.svg",
  "creative-commons-zero.svg",
  "creative-commons.svg",
  "critical-role.svg",
  "css3-alt.svg",
  "css3.svg",
  "cuttlefish.svg",
  "d-and-d-beyond.svg",
  "d-and-d.svg",
  "dailymotion.svg",
  "dashcube.svg",
  "deezer.svg",
  "delicious.svg",
  "deploydog.svg",
  "deskpro.svg",
  "dev.svg",
  "deviantart.svg",
  "dhl.svg",
  "diaspora.svg",
  "digg.svg",
  "digital-ocean.svg",
  "discord.svg",
  "discourse.svg",
  "dochub.svg",
  "docker.svg",
  "draft2digital.svg",
  "dribbble.svg",
  "dropbox.svg",
  "drupal.svg",
  "dyalog.svg",
  "earlybirds.svg",
  "ebay.svg",
  "edge-legacy.svg",
  "edge.svg",
  "elementor.svg",
  "ello.svg",
  "ember.svg",
  "empire.svg",
  "envira.svg",
  "erlang.svg",
  "ethereum.svg",
  "etsy.svg",
  "evernote.svg",
  "expeditedssl.svg",
  "facebook-f.svg",
  "facebook-messenger.svg",
  "facebook.svg",
  "fantasy-flight-games.svg",
  "fedex.svg",
  "fedora.svg",
  "figma.svg",
  "firefox-browser.svg",
  "firefox.svg",
  "first-order-alt.svg",
  "first-order.svg",
  "firstdraft.svg",
  "flickr.svg",
  "flipboard.svg",
  "fly.svg",
  "font-awesome.svg",
  "fonticons-fi.svg",
  "fonticons.svg",
  "fort-awesome-alt.svg",
  "fort-awesome.svg",
  "forumbee.svg",
  "foursquare.svg",
  "free-code-camp.svg",
  "freebsd.svg",
  "fulcrum.svg",
  "galactic-republic.svg",
  "galactic-senate.svg",
  "get-pocket.svg",
  "gg-circle.svg",
  "gg.svg",
  "git-alt.svg",
  "git.svg",
  "github-alt.svg",
  "github.svg",
  "gitkraken.svg",
  "gitlab.svg",
  "gitter.svg",
  "glide-g.svg",
  "glide.svg",
  "gofore.svg",
  "golang.svg",
  "goodreads-g.svg",
  "goodreads.svg",
  "google-drive.svg",
  "google-pay.svg",
  "google-play.svg",
  "google-plus-g.svg",
  "google-plus.svg",
  "google-wallet.svg",
  "google.svg",
  "gratipay.svg",
  "grav.svg",
  "gripfire.svg",
  "grunt.svg",
  "guilded.svg",
  "gulp.svg",
  "hacker-news.svg",
  "hackerrank.svg",
  "hashnode.svg",
  "hips.svg",
  "hire-a-helper.svg",
  "hive.svg",
  "hooli.svg",
  "hornbill.svg",
  "hotjar.svg",
  "houzz.svg",
  "html5.svg",
  "hubspot.svg",
  "ideal.svg",
  "imdb.svg",
  "instagram.svg",
  "instalod.svg",
  "intercom.svg",
  "internet-explorer.svg",
  "invision.svg",
  "ioxhost.svg",
  "itch-io.svg",
  "itunes-note.svg",
  "itunes.svg",
  "java.svg",
  "jedi-order.svg",
  "jenkins.svg",
  "jira.svg",
  "joget.svg",
  "joomla.svg",
  "js.svg",
  "jsfiddle.svg",
  "kaggle.svg",
  "keybase.svg",
  "keycdn.svg",
  "kickstarter-k.svg",
  "kickstarter.svg",
  "korvue.svg",
  "laravel.svg",
  "lastfm.svg",
  "leanpub.svg",
  "less.svg",
  "line.svg",
  "linkedin-in.svg",
  "linkedin.svg",
  "linode.svg",
  "linux.svg",
  "lyft.svg",
  "magento.svg",
  "mailchimp.svg",
  "mandalorian.svg",
  "markdown.svg",
  "mastodon.svg",
  "maxcdn.svg",
  "mdb.svg",
  "medapps.svg",
  "medium.svg",
  "medrt.svg",
  "meetup.svg",
  "megaport.svg",
  "mendeley.svg",
  "meta.svg",
  "microblog.svg",
  "microsoft.svg",
  "mix.svg",
  "mixcloud.svg",
  "mixer.svg",
  "mizuni.svg",
  "modx.svg",
  "monero.svg",
  "napster.svg",
  "neos.svg",
  "nfc-directional.svg",
  "nfc-symbol.svg",
  "nimblr.svg",
  "node-js.svg",
  "node.svg",
  "npm.svg",
  "ns8.svg",
  "nutritionix.svg",
  "octopus-deploy.svg",
  "odnoklassniki.svg",
  "old-republic.svg",
  "opencart.svg",
  "openid.svg",
  "opera.svg",
  "optin-monster.svg",
  "orcid.svg",
  "osi.svg",
  "padlet.svg",
  "page4.svg",
  "pagelines.svg",
  "palfed.svg",
  "patreon.svg",
  "paypal.svg",
  "perbyte.svg",
  "periscope.svg",
  "phabricator.svg",
  "phoenix-framework.svg",
  "phoenix-squadron.svg",
  "php.svg",
  "pied-piper-alt.svg",
  "pied-piper-hat.svg",
  "pied-piper-pp.svg",
  "pied-piper.svg",
  "pinterest-p.svg",
  "pinterest.svg",
  "pix.svg",
  "playstation.svg",
  "product-hunt.svg",
  "pushed.svg",
  "python.svg",
  "qq.svg",
  "quinscape.svg",
  "quora.svg",
  "r-project.svg",
  "raspberry-pi.svg",
  "ravelry.svg",
  "react.svg",
  "reacteurope.svg",
  "readme.svg",
  "rebel.svg",
  "red-river.svg",
  "reddit-alien.svg",
  "reddit.svg",
  "redhat.svg",
  "renren.svg",
  "replyd.svg",
  "researchgate.svg",
  "resolving.svg",
  "rev.svg",
  "rocketchat.svg",
  "rockrms.svg",
  "rust.svg",
  "safari.svg",
  "salesforce.svg",
  "sass.svg",
  "schlix.svg",
  "screenpal.svg",
  "scribd.svg",
  "searchengin.svg",
  "sellcast.svg",
  "sellsy.svg",
  "servicestack.svg",
  "shirtsinbulk.svg",
  "shopify.svg",
  "shopware.svg",
  "simplybuilt.svg",
  "sistrix.svg",
  "sith.svg",
  "sitrox.svg",
  "sketch.svg",
  "skyatlas.svg",
  "skype.svg",
  "slack.svg",
  "slideshare.svg",
  "snapchat.svg",
  "soundcloud.svg",
  "sourcetree.svg",
  "space-awesome.svg",
  "speakap.svg",
  "speaker-deck.svg",
  "spotify.svg",
  "stack-exchange.svg",
  "stack-overflow.svg",
  "stackpath.svg",
  "staylinked.svg",
  "steam-symbol.svg",
  "steam.svg",
  "sticker-mule.svg",
  "strava.svg",
  "stripe-s.svg",
  "stripe.svg",
  "studiovinari.svg",
  "stumbleupon-circle.svg",
  "stumbleupon.svg",
  "superpowers.svg",
  "supple.svg",
  "suse.svg",
  "swift.svg",
  "symfony.svg",
  "teamspeak.svg",
  "telegram.svg",
  "tencent-weibo.svg",
  "the-red-yeti.svg",
  "themeco.svg",
  "themeisle.svg",
  "think-peaks.svg",
  "tiktok.svg",
  "trade-federation.svg",
  "trello.svg",
  "tumblr.svg",
  "twitch.svg",
  "twitter.svg",
  "typo3.svg",
  "uber.svg",
  "ubuntu.svg",
  "uikit.svg",
  "umbraco.svg",
  "uncharted.svg",
  "uniregistry.svg",
  "unity.svg",
  "unsplash.svg",
  "untappd.svg",
  "ups.svg",
  "usb.svg",
  "usps.svg",
  "ussunnah.svg",
  "vaadin.svg",
  "viacoin.svg",
  "viadeo.svg",
  "viber.svg",
  "vimeo-v.svg",
  "vimeo.svg",
  "vine.svg",
  "vk.svg",
  "vnv.svg",
  "vuejs.svg",
  "watchman-monitoring.svg",
  "waze.svg",
  "weebly.svg",
  "weibo.svg",
  "weixin.svg",
  "whatsapp.svg",
  "whmcs.svg",
  "wikipedia-w.svg",
  "windows.svg",
  "wirsindhandwerk.svg",
  "wix.svg",
  "wizards-of-the-coast.svg",
  "wodu.svg",
  "wolf-pack-battalion.svg",
  "wordpress-simple.svg",
  "wordpress.svg",
  "wpbeginner.svg",
  "wpexplorer.svg",
  "wpforms.svg",
  "wpressr.svg",
  "xbox.svg",
  "xing.svg",
  "y-combinator.svg",
  "yahoo.svg",
  "yammer.svg",
  "yandex-international.svg",
  "yandex.svg",
  "yarn.svg",
  "yelp.svg",
  "yoast.svg",
  "youtube.svg",
  "zhihu.svg",
];
